import { gql } from '@apollo/client/core';

export const ADD_STUDENT_COURSE_TO_EXEMPT = gql`
  mutation AddStudentCourseToExempt($input: AddStudentCourseToExemptInput!) {
    addStudentCourseToExempt(input: $input) {
      success
      message
    }
  }
`;

export const UPDATE_STUDENT_COURSE_EXEMPTION = gql`
  mutation UpdateStudentCourseExemption($id: ID!, $fields: UpdateStudentCourseExemptionInput!) {
    updateStudentCourseExemption(id: $id, fields: $fields) {
      success
      message
    }
  }
`;

export const BULK_UPDATE_STUDENT_COURSE_EXEMPTION = gql`
  mutation BulkUpdateStudentCourseExemption($input: [BulkUpdateStudentCourseExemptionInput!]!) {
    bulkUpdateStudentCourseExemption(input: $input) {
      success
      message
    }
  }
`;

export const BULK_DELETE_STUDENT_COURSE_EXEMPTION = gql`
  mutation BulkDeleteStudentCourseExemption($ids: [ID!]!) {
    bulkDeleteStudentCourseExemption(ids: $ids) {
      success
      message
    }
  }
`;

export const BULK_EXEMPT_BY_STUDENTS = gql`
  mutation BulkExemptByStudents($input: BulkExemptByStudentsInput!) {
    bulkExemptByStudents(input: $input) {
      success
      message
    }
  }
`;

export const BULK_EXEMPT = gql`
  mutation BulkExempt($input: BulkExemptInput!) {
    bulkExempt(input: $input) {
      success
      message
    }
  }
`;

export const BULK_EXEMPT_FROM_EXCEL = gql`
  mutation BulkExemptFromExcel($matric_list: Upload!, $course_ids: [ID!]!) {
    bulkExemptFromExcel(matric_list: $matric_list, course_ids: $course_ids) {
      success
      message
    }
  }
`;
